import { DeleteOutlined, UserAddOutlined } from '@ant-design/icons';
import { Modal, Button, Row, Col, notification } from 'antd';
import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import FormularioNovoTerminal from '../app/features/FormularioNovoTerminal';
import FormularioNovoTerminalComercial from '../app/features/FormularioNovoTerminalComercial';

const ModalTC = (props: { quandoFinalizar: () => any; idLoja:any }) => {
  const [visible, setVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState('Form de cadastro de usuários');
  const [showCreationModal, setShowCreationModal] = useState(false);
  const openCreationModal = useCallback(() => setShowCreationModal(true), []);
  const closeCreationModal = useCallback(() => setShowCreationModal(false), []);
  const params = useParams<{ id: string }>();

  return (
    <>
      <Row align={'middle'}>
        <Col xs={24} lg={12} style={{ marginTop: '10px' }}>
     
            <Button
              type='primary'
              onClick={openCreationModal}
              icon={<UserAddOutlined />}
            >
              Terminais Comerciais
            </Button>

        </Col>
      </Row>
      <Modal
        title='Terminail Comercial'
        footer={null}
        visible={showCreationModal}
        onCancel={closeCreationModal}
        destroyOnClose
        forceRender={false}
      >
        <FormularioNovoTerminalComercial
          onSuccess={() => {
            closeCreationModal();
            props.quandoFinalizar();
            notification.success({
              message: 'Terminal cadastrado com sucesso',
              top: 80,
            });
          }}
          idLoja={props.idLoja}
        ></FormularioNovoTerminalComercial>
      </Modal>
    </>
  );
};

export default ModalTC;
